import React from "react";
import "../Css/Njs.css";

// import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";
import { NFooter } from "./NFooter";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const NodeFirstPage = () => {
  const [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_node">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/njslogo.png"}
                      width="85%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingBottom: "65px",
                paddingTop: "60px",
              }}
            >
              <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div className="mt-4">
                    <h1 className="py_h1">NodeJs Tutorial</h1>
                  </div>
                  <div>
                    <p>
                      In this easy NodeJs tutorial, you will learn the usage of
                      NodeJs, why to learn NodeJs and how to run a NodeJs step
                      by step. Whether you are a beginner in programming or an
                      experienced programmer, you can learn NodeJs easily. In
                      This tutorial, all examples are based on the latest
                      version of NodeJs.
                    </p>
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
              {/* <!-- <hr style="color: white" /> --> */}

              <div className="row">
                <div className="mt-4">
                  <h1 className="py_h1">About NodeJs Language.</h1>
                </div>
                <div>
                  <p>
                    Node.js is an open-source and cross-platform runtime
                    environment for executing JavaScript code outside a browser.
                    You need to remember that NodeJS is not a framework and it’s
                    not a programming language. Most people are confused and
                    understand it’s a framework or a programming language. We
                    often use Node.js for building back-end services like APIs
                    like Web App or Mobile App. It’s used in production by large
                    companies such as Paypal, Uber, Netflix, Walmart, and so on.
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mt-5">
                  <div>
                    <h1
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Advantages of NodeJS ?
                    </h1>
                    <ul>
                      <li className="text-light">
                        <span style={{ fontWeight: "bold" }}>
                          Easy Scalability:{" "}
                        </span>
                        Developers prefer to use Node.js because it is easily
                        scaling the application in both horizontal and vertical
                        directions. We can also add extra resources during the
                        scalability of the application.
                      </li>
                      <li className="text-light">
                        <span style={{ fontWeight: "bold" }}>
                          {" "}
                          Real-time web apps:{" "}
                        </span>
                        If you are building a web app you can also use PHP, and
                        it will take the same amount of time when you use
                        Node.js, But if I am talking about building chat apps or
                        gaming apps Node.js is much more preferable because of
                        faster synchronization. Also, the event loop avoids HTTP
                        overloaded for Node.js development.
                      </li>
                      <li className="text-light">
                        <span style={{ fontWeight: "bold" }}>
                          Easy to learn and code:{" "}
                        </span>
                        NodeJs is easy to learn and code because it uses
                        JavaScript. If you are a front-end developer and have a
                        good grasp of JavaScript you can easily learn and build
                        the application on NodeJS
                      </li>
                      <li className="text-light">
                        <span style={{ fontWeight: "bold" }}>
                          Advantage of Caching:{" "}
                        </span>
                        It provides the caching of a single module. Whenever
                        there is any request for the first module, it gets
                        cached in the application memory, so you don’t need to
                        re-execute the code.
                      </li>
                      <li className="text-light">
                        <span style={{ fontWeight: "bold" }}>Fast Suite:</span>{" "}
                        NodeJs runs on the V8 engine developed by Google. Event
                        loop in NodeJs handles all asynchronous operation so
                        NodeJs acts like a fast suite and all the operations can
                        be done quickly like reading or writing in the database,
                        network connection, or file system
                      </li>
                      <li className="text-light">
                        <span style={{ fontWeight: "bold" }}>
                          Corporate Support:{" "}
                        </span>{" "}
                        Most of the well-known companies like Walmart, Paypal,
                        Microsoft, Yahoo are using NodeJS for building the
                        applications. NodeJS uses JavaScript, so most of the
                        companies are combining front-end and backend Teams
                        together into a single unit.
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="col-md-4 mt-5">
                  <div>
                    <h1
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Python Application
                    </h1>
                    <ul>
                      <li className="text-light">YouTube</li>
                      <li className="text-light">Google</li>
                      <li className="text-light">Instagram</li>
                      <li className="text-light">Quora</li>
                      <li className="text-light">DropBox.</li>
                      <li className="text-light">Reddit.</li>
                    </ul>
                  </div>
                </div> */}
                <div className="col-md-6 mt-5">
                  <div>
                    <h1
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Features Of NodeJs.
                    </h1>
                    <ul>
                      <li className="text-light">
                        It’s easy to get started and can be used for prototyping
                        and agile development
                      </li>
                      <li className="text-light">
                        It uses JavaScript everywhere, so it’s easy for a
                        JavaScript programmer to build back-end services using
                        Node.js
                      </li>
                      <li className="text-light">
                        It provides fast and highly scalable services
                      </li>
                      <li className="text-light">
                        Large ecosystem for open source library.
                      </li>
                      <li className="text-light">
                        Source code cleaner and consistent
                      </li>
                      <li className="text-light">
                        Large ecosystem for open source library.
                      </li>
                      <li className="text-light">
                        It has Asynchronous or Non-blocking nature.
                      </li>
                    </ul>
                  </div>
                  <h1
                    style={{
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Application of NodeJS
                  </h1>
                  <ul>
                    <li className="text-light">Real-Time Chats,</li>
                    <li className="text-light">
                      Real-time collaboration tools,
                    </li>
                    <li className="text-light">JSON APIs based application</li>
                    <li className="text-light">
                      Complex Single-Page applications,
                    </li>
                    <li className="text-light">JSON APIs based application</li>
                    <li className="text-light">Streaming apps</li>
                  </ul>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-6">
                  <h1 className="py_h1">What Can Node.js Do?</h1>
                  <ul>
                    <li className="text-light">
                      Node.js can generate dynamic page content
                    </li>
                    <li className="text-light">
                      Node.js can create, open, read, write, delete, and close
                      files on the server
                    </li>
                    <li className="text-light">
                      Node.js can collect form data
                    </li>
                    <li className="text-light">
                      Node.js can add, delete, modify data in your database
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h1 className="py_h1">What is a Node.js File?</h1>
                  <ul>
                    <li className="text-light">
                      Node.js files contain tasks that will be executed on
                      certain events
                    </li>
                    <li className="text-light">
                      A typical event is someone trying to access a port on the
                      server
                    </li>
                    <li className="text-light">
                      Node.js files must be initiated on the server before
                      having any effect
                    </li>
                    <li className="text-light">
                      Node.js files have extension ".js"
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <PyFooter /> */}
            <NFooter />
          </>
        )}
      </div>
    </>
  );
};
